import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useSoftphone } from "../context/SoftphoneContext";

function Dashboard({ user }) {
  // const [toNumber, setToNumber] = useState('');
  // const [message, setMessage] = useState('');
  // const [messageType, setMessageType] = useState('');
  const [stats, setStats] = useState({ whitelist: 0, blacklist: 0, calls: 0 });

  const {
    softphoneStatus,
    activeCall,
    // makeTwilioCall,
    hangUp,
    // incomingFrom,
    // answerCall,
  } = useSoftphone();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      
      const [whitelistRes, blacklistRes, callsRes] = await Promise.all([
        axios.get('/api/whitelist', { headers }),
        axios.get('/api/blacklist', { headers }),
        axios.get('/api/calls', { headers })
      ]);

      setStats({
        whitelist: whitelistRes.data.whitelist?.length || 0,
        blacklist: blacklistRes.data.blacklist?.length || 0,
        calls: callsRes.data.calls?.length || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  // const handleMakeCall = async (e) => {
  //   e.preventDefault();
  //   setMessage('');

  //   try {
  //     const token = localStorage.getItem('token');
  //     await axios.post('/api/calls/outgoing', 
  //       { to: toNumber },
  //       { headers: { Authorization: `Bearer ${token}` }}
  //     );
  //     setMessage('Call initiated successfully! Your Twilio number will be displayed to the recipient.');
  //     setMessageType('success');
  //     setToNumber('');
  //     setTimeout(() => setMessage(''), 5000);
  //   } catch (error) {
  //     setMessage(error.response?.data?.message || 'Failed to initiate call');
  //     setMessageType('danger');
  //   }
  // };

  // const handleMakeCall = async (e) => {
  //   e.preventDefault();
  //   setMessage('');

  //   // if (!makeTwilioCall || softphoneStatus !== 'Device ready') {
  //   //     setMessage('Softphone is not ready. Status: ' + softphoneStatus);
  //   //     setMessageType('danger');
  //   //     return;
  //   // }
    
  //   try {
  //     await makeTwilioCall(toNumber); 
  //     setMessage(`Call initiated to ${toNumber}. Connecting...`);
  //     setMessageType('info');
  //     setToNumber('');
  //   } catch (error) {
  //     setMessage(error.message || 'Failed to start call.');
  //     setMessageType('danger');
  //   }
  // };

  return (
    <Container className="mainWrapper">
      {/* <Alert
        variant={activeCall ? "success" : "secondary"}
        className="text-center"
      >
        {activeCall && (
          <Button size="sm" variant="danger" onClick={hangUp} className="ms-3">
            Hang Up
          </Button>
        )}
      </Alert> */}
      <Row className="mb-4">
        <Col>
          <Card className="text-center bg-primary text-white">
            <Card.Body className="py-4">
              <h1 className="mb-2">
                {/* <i className="fas fa-shield-alt me-2"></i> */}
                <img
                  src="/logo.png"
                  alt="CallBunker Logo"
                  className="m-2 mt-0 mb-3"
                  style={{ width: "45px", height: "44px" }}
                />
                CallBunker Dashboard
              </h1>
              <p className="mb-3">Welcome, {user.name}!</p>
              <div className="defense-badge bg-success">
                <i className="fas fa-phone me-2"></i>
                Your Defense Number: {user.twilioNumber || "Assigning..."}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
              <h3>{stats.whitelist}</h3>
              <p className="text-muted mb-0">Trusted Contacts</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-ban fa-3x text-danger mb-3"></i>
              <h3>{stats.blacklist}</h3>
              <p className="text-muted mb-0">Blocked Numbers</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-phone fa-3x text-primary mb-3"></i>
              <h3>{stats.calls}</h3>
              <p className="text-muted mb-0">Total Calls</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        {/* <Col lg={6} className="mb-4">
          <Card>
            <Card.Body>
              <h4>
                <i className="fas fa-phone-alt me-2 text-primary"></i>
                Make Protected Call
              </h4>
              <p className="text-muted">
                Call anyone with your Twilio number as caller ID
              </p>

              {message && <Alert variant={messageType}>{message}</Alert>}

              <Form onSubmit={handleMakeCall}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    value={toNumber}
                    onChange={(e) => setToNumber(e.target.value)}
                    placeholder="+1234567890"
                    required
                  />
                  <Form.Text className="text-muted">
                    The recipient will see your CallBunker number
                  </Form.Text>
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  <i className="fas fa-phone me-2"></i>
                  Make Call
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col> */}

        <Col lg={6} className="">
          <Card>
            <Card.Body>
              <h4>
                <i className="fas fa-info-circle me-2 text-info"></i>
                How It Works
              </h4>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fas fa-check text-success me-2"></i>
                  Share your PIN ({user.pin ? "****" : "Not set"}) or voice code
                  with trusted contacts
                </li>
                <li className="mb-2">
                  <i className="fas fa-check text-success me-2"></i>
                  When someone calls your defense number, they must authenticate
                </li>
                <li className="mb-2">
                  <i className="fas fa-check text-success me-2"></i>
                  After 3 failed attempts, they're automatically blocked
                </li>
                <li className="mb-2">
                  <i className="fas fa-check text-success me-2"></i>
                  Successful callers are auto-added to your whitelist
                </li>
                <li className="mb-2">
                  <i className="fas fa-check text-success me-2"></i>
                  Outgoing calls show your CallBunker number, not your real
                  number
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Dashboard;
